export default __webpack_public_path__ + "static/media/fridge1-before2-1920w.76337609.webp";